module.exports = __webpack_public_path__ + "static/img/null.4c13ad6b.png";